import { Box, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Menu, MenuItem, Tooltip } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { MdEdit } from 'react-icons/md'
import { Button } from 'src/Common/ui/button'
import '../../Styles/ViewRiskById.css'
import { useRiskStore } from './Store/RiskStore'
import { useLocation, useNavigate, useParams } from 'react-router'
import Loading from 'src/Common/ui/Loading'
import { toast } from 'react-toastify'
import * as RoutePath from '../../Entities/RoutePath'
import AddRisk from './AddRisk'
import { cn, featValid } from 'src/lib/utils'
import RiskInformation from './RiskInformation'
import * as RiskType from '../../Entities/RiskTypes'
import AssesmentView from './AssesmentView'
import MitigationView from './MitigationView'
import MonitoringView from './MonitoringView'
import AssesmentEdit from './AssesmentEdit'
import MitigationEdit from './MitigationEdit'
import MonitoringEdit from './MonitoringEdit'
import * as EndPoints from '../../Entities/EndPoints'
import { useGovernanceStore } from '../Onboarding/Store/GovernanceStore'
import CommentsDrawer from './CommentsDrawer'
import ViewComments from './ViewComments'
import { STATUS_ENUMS } from 'src/Entities/StatusEnums'
import { UPDATE_RISK } from 'src/Entities/Features'
// import { Card } from 'src/Common/ui/card'
import { VerticalTimelineContainer } from '../Governance/VerticalTimeline/VerticalTimelineContainer'
import { INITIATE } from 'src/Entities/CommonEntities'
import { PeriodicityContainer } from '../Governance/Periodicity/PeriodicityContainer'
import Axios from 'src/Axios'
import { useSettingsStore } from '../SettingsContainer/Store/Store'
import { MoreVerticalIcon } from 'lucide-react'
import IssueSelect from 'src/Common/Icon/IssueSelect'

const ViewRiskByID = () => {
    const instance = Axios.getInstance()

    const { createRiskDataLoading, RiskDetailsById, getRidkDetailsById, CreateRisk, getRiskDetails, getRiskHistory, getRiskPeriodicity, riskDetailsLoading } = useRiskStore()
    const { configurationData } = useSettingsStore()
    const getRiskHistoryData = useRiskStore((state) => state.getRiskHistoryData)
    const RiskDetailsByIdLoading = useRiskStore((state) => state.RiskDetailsByIdLoading)
    const params = useParams()
    const [ isEditTrue, setIsEditTrue ] = useState(false)
    const [ formData, setformData ] = useState({})
    const [ riskTypes, setRiskTypes ] = useState([])
    const [ allCategories, setAllCategories ] = useState([])
    const [ openWithdrawnPopup, setOpenWithdrawnPopup ] = useState(false)
    const [ impactedDepartments, setImpactedDepartments ] = useState([])
    const [ riskStatusTabs, setRiskStatusTabs ] = useState(RiskType.RISK_INFO_STATUS)
    const [ riskScore, setRiskScore ] = useState([{ impact: null, Probability: null, RiskScore: null }])
    const loginId = localStorage.getItem('userId')

    const userName = localStorage.getItem('userName')
    const navigate = useNavigate()
    const location = useLocation()
    const riskDetails = location?.state?.riskDetails
    const checkedCount = RiskDetailsById?.mitigation?.taskLists?.filter((filData, _) => filData?.actions !== 11)?.filter(item => item.actions === RiskType.TASK_COMPLETED_STATUS).length
    const taskPercentage = (checkedCount / RiskDetailsById?.mitigation?.taskLists?.filter((filData, _) => filData?.actions !== 11)?.length) * 100
    const [ openConfirmDialog, setOpenConfirmDialog ] = useState(false)
    const [ selectedRiskId, setSelectedRiskId ] = useState(null)
    const [ CommentsDrawerTitle, setCommentsDrawerTitle ] = useState('')

    const L1Approval = configurationData?.filter((filterData) => filterData?.kindId === 3)[0]?.values === 1
    const L2Approval = configurationData?.filter((filterData) => filterData?.kindId === 3)[1]?.values === 1
    const [ preApprovalPopup, setPreApprovalPopup ] = useState(false)
    const [ statusEnum, setStatusEnum ] = useState({
        status: 1,
        level1: 8,
        level2: 8,
        convertIssue: false
    })
    useEffect(() => {
        if (params?.riskId) {
            getRidkDetailsById(Number(riskDetails?.riskId), loginId)
        }
    }, [params?.riskId])

    const getAllRiskTypes = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllRiskTypes')
            return response.data
        } catch (error) {
            console.error('Error fetching risk types:', error)
            throw error
        }
    }

    const getAllCategories = async () => {
        try {
            const response = await instance.get(EndPoints.API_ENDPOINT + '/masterController/GetAllCategories')
            return response.data
        } catch (error) {
            console.error('Error fetching categories:', error)
            throw error
        }
    }
    const { getDepOrganizations, allDepartments } = useGovernanceStore()
    const orgId = localStorage.getItem('orgId')
    useEffect(() => {
        if (!isEditTrue) {
            getRidkDetailsById(riskDetails?.riskId, userId)
        }
    }, [isEditTrue])
    useEffect(() => {
        if (allDepartments?.length > 0) {
            setImpactedDepartments(allDepartments)
        }
    }, [allDepartments])

    useEffect(() => {
        const fetchRiskTypes = async () => {
            try {
                const types = await getAllRiskTypes()
                setRiskTypes(types)
            } catch (error) {
                console.error('Error fetching risk types:', error)
            }
            try {
                const types = await getAllCategories()
                setAllCategories(types)
            } catch (error) {
                console.error('Error fetching all categories:', error)
            }
            try {
                getDepOrganizations(orgId)
            } catch (error) {
                console.error('Error fetching imp dept:', error)
            }
        }

        fetchRiskTypes()
    }, [])

    useEffect(() => {
        if (RiskDetailsById?.riskInformation?.id) {
            setStatusEnum({ ...statusEnum, status: RiskDetailsById?.riskInformation?.status, level1: RiskDetailsById?.riskInformation?.level1, level2: RiskDetailsById?.riskInformation?.level2 })
            setformData({
                ...formData,
                id: RiskDetailsById?.riskInformation?.id,
                ContextId: RiskDetailsById?.riskInformation?.contextId,
                Title: RiskDetailsById?.riskInformation?.title,
                Description: RiskDetailsById?.riskInformation?.description,
                IdentifiedOn: RiskDetailsById?.riskInformation?.identifiedOn,
                Type: riskTypes?.find((findDt) => findDt?.name === RiskDetailsById?.riskInformation?.type)?.id,
                Category: allCategories?.find((findDt) => findDt?.name === RiskDetailsById?.riskInformation?.category)?.id,
                ImpactedDepartnments: RiskDetailsById?.riskInformation?.impactedDepartment?.map((str) => {
                    const foundObj = impactedDepartments?.find((obj) => obj.name === str)
                    return foundObj ? foundObj.id : null
                }),
                ImpactOfRisk: RiskDetailsById?.riskInformation?.riskScore[0]?.impactOfRisk,
                RiskOwner: impactedDepartments?.find((findDt) => findDt?.name === RiskDetailsById?.riskInformation?.ownerDepartmentId)?.id,
                CreatedBy: RiskDetailsById?.riskInformation?.createdBy,
                CreatedDate: RiskDetailsById?.riskInformation?.createdAt,
                SupportingDocuments: RiskDetailsById?.riskInformation?.supportingDocuments || [],

                internalExternal: RiskDetailsById?.riskInformation?.sourceRiskId,
                riskScore: RiskDetailsById?.riskInformation?.riskScore?.map((mapData) => {
                    return {
                        id: mapData?.id,
                        riskId: mapData?.riskId,
                        user: mapData?.user,
                        userId: mapData?.userId,
                        role: mapData?.role,
                        status: mapData?.status,
                        impact: mapData?.impact,
                        Probability: mapData?.probability,
                        RiskScore: mapData?.riskScore,
                        ImpactOfRisk: mapData?.impactOfRisk
                    }
                }),
                mitigationTasks: RiskDetailsById?.riskInformation?.suggestedMitigation?.map((mapDt) => {
                    return { ...mapDt, task: mapDt?.name }
                })
            })
        }

        if (RiskDetailsById?.riskInformation?.status === RiskType.ASSESSMENT_STATUS_NUM) {
            setRiskStatusTabs(RiskType.ASSESSMENT_STATUS)
        } else if (RiskDetailsById?.riskInformation?.status === RiskType.MITIGATION_STATUS_NUM) {
            setRiskStatusTabs(RiskType.MITIGATION_STATUS)
        } else if (RiskDetailsById?.riskInformation?.status === RiskType.MONITORING_STATUS_NUM) {
            setRiskStatusTabs(RiskType.MONITORING_STATUS)
        } else {
            setRiskStatusTabs(RiskType.RISK_INFO_STATUS)
        }
    }, [ RiskDetailsById?.riskInformation?.id, allCategories?.length, impactedDepartments?.length, riskTypes?.length ])
    const handleClickEdit = () => {
        handleClose()
        setIsEditTrue(!isEditTrue)
        if (riskStatusTabs === RiskType.ASSESSMENT_STATUS) {
            const threePointEstimate = RiskDetailsById?.analyzeResponse?.threePointEstimate
            const decisionTreeAnalysis = RiskDetailsById?.analyzeResponse?.decisionTreeAnalysis
            const expectedMonetaryValue = RiskDetailsById?.analyzeResponse?.expectedMonetaryValue
            const qualitativeRiskAssessment = RiskDetailsById?.analyzeResponse?.qualitativeRiskAssessment
            if (riskStatusTabs === RiskType.ASSESSMENT_STATUS) {
                setRiskScore(
                    {
                        ...riskScore,
                        id: qualitativeRiskAssessment?.id,
                        riskId: qualitativeRiskAssessment?.riskId,
                        user: qualitativeRiskAssessment?.user,
                        userId: qualitativeRiskAssessment?.userId,
                        role: qualitativeRiskAssessment?.role,
                        status: qualitativeRiskAssessment?.status,
                        impact: qualitativeRiskAssessment?.impact,
                        Probability: qualitativeRiskAssessment?.probability,
                        RiskScore: qualitativeRiskAssessment?.riskScore
                    }
                )
            } else {
                setRiskScore({
                    ...riskScore,
                    id: qualitativeRiskAssessment?.id,
                    riskId: qualitativeRiskAssessment?.riskId,
                    user: qualitativeRiskAssessment?.user,
                    userId: qualitativeRiskAssessment?.userId,
                    role: qualitativeRiskAssessment?.role,
                    status: qualitativeRiskAssessment?.status,
                    impact: qualitativeRiskAssessment?.impact,
                    Probability: qualitativeRiskAssessment?.probability,
                    RiskScore: qualitativeRiskAssessment?.riskScore
                })
            }
            setformData({
                ...formData,
                ImpactOfRiskScore: qualitativeRiskAssessment?.impactOfRisk,
                impactProbabilityJustification: qualitativeRiskAssessment?.probabilityJustification,
                threePointEstimate: {
                    // ...formData?.threePointEstimate,
                    id: threePointEstimate?.id,
                    riskId: threePointEstimate?.riskId,
                    estimateId: threePointEstimate?.estimateId,
                    treePointDiscription: threePointEstimate?.description,
                    optimisticCost: threePointEstimate?.optimisticCost,
                    optimisticDays: threePointEstimate?.optimisticDays,
                    pessimisticDays: threePointEstimate?.pessimisticDays,
                    pessimisticCost: threePointEstimate?.pessimisticCost,
                    mostLikelyDays: threePointEstimate?.mostLikelyDays,
                    mostLikelyCost: threePointEstimate?.mostLikelyCost,
                    durationEstimation: threePointEstimate?.durationEstimation,
                    costEstimation: threePointEstimate?.costEstimation
                },
                decisionTreeAnalysis: {
                    // ...formData?.decisionTreeAnalysis,
                    decisionDiscription: decisionTreeAnalysis?.description,
                    bestDaysAlternative: decisionTreeAnalysis?.dayDecision,
                    bestCostAlternative: decisionTreeAnalysis?.costDecision,
                    noOfAlternatives: decisionTreeAnalysis?.alternativesNo,
                    id: decisionTreeAnalysis?.id,
                    riskId: decisionTreeAnalysis?.alternativesNo > 0 ? decisionTreeAnalysis?.riskId : 0,
                    decisionId: decisionTreeAnalysis?.alternativesNo > 0 ? decisionTreeAnalysis?.decisionId : 0,
                    alternativesData: decisionTreeAnalysis?.alternatives?.map((mapData) => {
                        return {
                            id: mapData?.id,
                            decisionTreeId: mapData?.decisionTreeId,
                            alternativeName: mapData?.alternativeName,
                            noOfOutcome: mapData?.outcomeNo,
                            outcomesData: mapData?.outcomes?.map((childMapData) => {
                                return {
                                    id: childMapData?.id,
                                    alternativeId: childMapData?.alternativeId,
                                    outComesDiscription: childMapData?.outcomeDescription,
                                    outComesProbability: childMapData?.probability,
                                    outComesCost: childMapData?.cost,
                                    outComesDays: childMapData?.days
                                }
                            })
                        }
                    })
                },
                noOfRisks: expectedMonetaryValue?.risksNo,
                emvId: expectedMonetaryValue?.id,
                totalEMV: expectedMonetaryValue?.totalEMV,
                noOfRisksData: expectedMonetaryValue?.inputs?.map((mapData) => {
                    return {
                        id: mapData?.id,
                        riskId: expectedMonetaryValue?.risksNo > 0 ? mapData?.riskId : 0,
                        emvId: mapData?.emvId,
                        riskName: mapData?.riskName,
                        probability: mapData?.probability,
                        cost: mapData?.cost
                    }
                })
            })
        }
    }

    const handleClickTab = (value) => {
        setRiskStatusTabs(value)
        setIsEditTrue(false)
    }

    const userDepartment = localStorage.getItem('department')
    const userId = localStorage.getItem('userId')
    const userRoles = JSON.parse(localStorage.getItem('userRoles'))
    const RaisedManagerValidation = () => {
        return RiskDetailsById.riskInformation?.level1 === STATUS_ENUMS.Pending && RiskDetailsById.riskInformation?.department === userDepartment && verifyManagerOrVacant()
    }
    const ownedManagerValidation = () => {
        return RiskDetailsById.riskInformation?.level1 === STATUS_ENUMS.Approved && RiskDetailsById.riskInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()
    }
    const RaisedManagerCloseValidation = () => {
        return (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Completed || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.MitigationCompleted) && RiskDetailsById.riskInformation?.department === userDepartment && verifyManagerOrVacant()
    }
    const addRiskRef = useRef()
    const handleApprove = (type = null, message) => {
        let status = statusEnum
        if (RaisedManagerValidation()) {
            status = { ...status, level1: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Active }
            setStatusEnum({ ...statusEnum, level1: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Active })
        }
        if (ownedManagerValidation()) {
            if (type === 'Mitigation') {
                const find = RiskType.MITITGATION_APPROACH.find((ele) => RiskDetailsById?.mitigation?.approachId === RiskType.REDUCTION_ID && ele.value === RiskDetailsById?.mitigation?.approachId)
                if (find) {
                    status = { ...status, status: STATUS_ENUMS.Monitering }
                    setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Monitering })
                } else {
                    status = { ...status, status: RiskDetailsById?.mitigation?.approachId !== RiskType.REDUCTION_ID ? STATUS_ENUMS.MitigationCompleted : STATUS_ENUMS.Completed }
                    setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Approved, status: RiskDetailsById?.mitigation?.approachId !== RiskType.REDUCTION_ID ? STATUS_ENUMS.MitigationCompleted : STATUS_ENUMS.Completed })
                }
            } else if (type === 'Monitoring') {
                if (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Monitering) {
                    status = { ...status, status: STATUS_ENUMS.Completed }
                    setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.Completed })
                }
            } else if (type === 'Convert') {
                status = { ...status, status: STATUS_ENUMS.Closed, level1: STATUS_ENUMS.Approved, level2: STATUS_ENUMS.Approved, convertIssue: true }
                setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.Completed, convertIssue: true })
            } else {
                setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Analyze })
                status = { ...status, level2: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Analyze }
            }
        }
        if (RaisedManagerCloseValidation()) {
            // eslint-disable-next-line no-unused-vars
            status = { ...status, status: STATUS_ENUMS.Closed }
        }
        handleAddRisk(status, message)

        // callBack()
    }
    // const customNavigate = useCustomNavigate()
    const [ loading, setLoading ] = useState(false)
    const handleAddRisk = async (status, message) => {
        try {
            const selectedFiles = formData?.SupportingDocuments || []
            const commentType = RiskDetailsById?.riskInformation?.department === userDepartment ? 'raisedRemarks' : 'ownerRemarks'
            const addRiskFormate = {
                RiskId: formData?.id,
                ContextId: formData?.ContextId,
                Title: formData?.Title,
                Description: formData?.Description,
                IdentifiedOn: formData?.IdentifiedOn,
                SourceRiskId: formData.internalExternal === 'Internal' ? 1 : 2,
                Type: formData?.Type,
                Category: formData?.Category,
                ImpactedDepartmentIds: formData?.ImpactedDepartnments,
                OwnerDepartmentId: formData?.RiskOwner,
                Scores: formData.riskScore?.map((mapData) => {
                    return {
                        id: mapData.id,
                        riskId: isEditTrue ? formData?.id : 0,
                        levelId: 1,
                        userId: mapData?.userId || loginId,
                        user: mapData?.user || userName,
                        impact: mapData?.impact,
                        probability: mapData?.Probability,
                        riskScore: mapData?.RiskScore,
                        impactOfRisk: mapData?.ImpactOfRisk,
                        probabilityJustification: '',
                        createdBy: loginId,
                        createdAt: new Date()?.toISOString(),
                        modifiedBy: loginId,
                        modifiedAt: new Date()?.toISOString(),
                        status: STATUS_ENUMS.Active
                    }
                }),
                SuggestedMitigation: formData.mitigationTasks?.map(mapDt => {
                    return {
                        id: mapDt.id,
                        riskId: mapDt.riskId,
                        name: mapDt?.task,
                        startDate: typeof mapDt?.startDate === 'object' ? mapDt?.startDate?.toISOString() : mapDt?.startDate || '',
                        endDate: typeof mapDt?.endDate === 'object' ? mapDt?.endDate?.toISOString() : mapDt?.endDate || '',
                        departmentId: '',
                        actions: mapDt?.actions || '',
                        responsible: '',
                        createdBy: mapDt?.createdBy || loginId,
                        createdAt: new Date().toISOString(),
                        modifiedBy: mapDt?.modifiedBy || loginId,
                        modifiedAt: new Date().toISOString(),
                        status: mapDt.status
                    }
                }),
                Level1: status.level1,
                issueConverted: status.convertIssue || false,
                Level2: message === 'Risk [ID] has been accepted' && (L1Approval && !L2Approval) ? STATUS_ENUMS.Approved : status.level2,
                [commentType]: comments,
                CreatedBy: isEditTrue ? formData?.CreatedBy : loginId,
                CreatedAt: isEditTrue ? formData?.CreatedDate : new Date().toISOString(),
                ModifiedBy: loginId,
                ModifiedAt: new Date().toISOString(),
                Status: message === 'Risk [ID] has been accepted' && (L1Approval && !L2Approval) ? STATUS_ENUMS.Analyze : status.status
            }

            const formValue = new FormData()

            Object.entries(addRiskFormate).forEach(([ key, value ]) => {
                if (Array.isArray(value)) {
                    if (key === 'Scores') {
                        value.forEach((score, index) => {
                            Object.entries(score).forEach(([ scoreKey, scoreValue ]) => {
                                formValue.append(`Scores[${index}].${scoreKey}`, scoreValue)
                            })
                        })
                    } else if (key === 'ImpactedDepartmentIds') {
                        addRiskFormate?.ImpactedDepartmentIds?.forEach((deptId, index) => {
                            formValue.append(`ImpactedDepartmentIds[${index}]`, deptId)
                        })
                    } else if (key === 'SuggestedMitigation') {
                        addRiskFormate?.SuggestedMitigation?.forEach((task, index) => {
                            Object.entries(task).forEach(([ taskKey, taskValue ]) => {
                                formValue.append(`SuggestedMitigation[${index}].${taskKey}`, taskValue)
                            })
                        })
                    } else {
                        value.forEach(item => formValue.append(key, item))
                    }
                } else {
                    formValue.append(key, value)
                }
            })

            selectedFiles?.forEach((task, index) => {
                Object.entries(task).forEach(([ taskKey, taskValue ]) => {
                    formValue.append(`SupportingDocuments[${index}].${taskKey}`, taskValue)
                })
            })
            await CreateRisk(loginId, formValue)
                .then(async (res) => {
                    if (res.data === 'Failed to add risk: Risk Withdrawn') {
                        setOpenWithdrawnPopup(true)
                        setEditState({ right: false })
                    } else if (res?.data) {
                        toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{message?.replace('[ID]', res?.data)}</p></p>, {
                            position: 'top-right', theme: 'light'
                        })
                        setEditState({ right: false })
                        setEditState({ right: false })
                        if (message === 'Risk [ID] has been closed') {
                            // if (status.convertIssue) {
                            //     toast.success(<p className='w-[100%] flex flex-row justify-evenly items-center' ><p>{`Risk ${res?.data} has been converted to Issue`}</p></p>, {
                            //         position: 'top-right', theme: 'light'
                            //     })
                            //     navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.ISSUE.URI + RoutePath.ISSUE.Add_ISSUE + '?riskId=' + res?.data)
                            // } else {
                            navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.HISTORY.URI)
                            // }
                        } else if (message === 'Risk [ID] has been successfully withdrawn') {
                            navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        } else if (message === 'Risk [ID] has been accepted') {
                            setLoading(true)
                            instance.post(EndPoints.API_ENDPOINT + `/risk/RiskHistoryUpdateEntry?riskId=${formData?.id}&loginId=${loginId}&type=2`)
                                .then((tmlnRes) => tmlnRes)
                                .catch((err) => err)
                                .finally(() => {
                                    setLoading(false)
                                    navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                                })
                        } else if (message === 'Risk [ID] has been denied') {
                            navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                            setEditState({ right: false })
                        } else if (message === 'Risk [ID] has been rejected') {
                            navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                        } else {
                            if (RiskDetailsById.mitigation.approachId === STATUS_ENUMS.Approved && RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Monitering) {
                                navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                            } else if (RiskDetailsById.mitigation.approachId !== STATUS_ENUMS.Approved && RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Analyze) {
                                navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                            } else {
                                navigate(`${'#' + res?.data}`, { state: { riskDetails: { riskId: formData?.id } } })
                            }
                        }
                        getRidkDetailsById(Number(riskDetails?.riskId), loginId)
                        await getRiskDetails(1, 30, 1, 1, loginId)
                        setEditState({ right: false })
                    } else {
                        toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>Risk could not be withdrawn. Please try again!</p></p>, {
                            position: 'top-right', theme: 'light'
                        })
                    }
                    setEditState({ right: false })
                })
                .catch((err) => {
                    toast.error(<p className='w-[70%] flex flex-row justify-evenly items-center' ><p color='hsl(var(--card))'>Risk could not be withdrawn. Please try again!</p></p>, {
                        position: 'top-right', theme: 'light'
                    })
                    console.error(err)
                })
        } catch (error) {
            console.error('Error adding risk:', error)
        }
    }
    const [ comments, setComments ] = useState('')
    const [ editState, setEditState ] = useState({ right: false })
    const [ isViewComments, setIsViewComments ] = useState({ right: false })
    const ref = useRef()
    const periodRef = useRef()
    const toggleDrawer = () => {
        ref.current.toggleDraw()
    }
    const periodToggleDraw = () => {
        periodRef.current.toggleDraw()
    }
    const handleReject = (message) => {
        let status = statusEnum
        if (RaisedManagerValidation()) {
            status = { ...status, level1: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.Active }
            setStatusEnum({ ...statusEnum, level1: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.Active })
        }
        if (ownedManagerValidation()) {
            if (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.DisputeApprove) {
                status = { ...status, level2: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.DisputeClosed }
                setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.DisputeClosed })
            } else {
                status = { ...status, level2: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.Active }
                setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Rejected, status: STATUS_ENUMS.Active })
            }
        }
        handleAddRisk(status, message)
    }
    const handleRetrieve = (message) => {
        let status = statusEnum
        status = { ...status, level1: STATUS_ENUMS.Pending, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Retrieve }
        handleAddRisk(status, message)
    }
    const handleDisMove = (message) => {
        let status = statusEnum
        status = { ...status, status: STATUS_ENUMS.Dispute }
        setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.Dispute })
        handleAddRisk(status, message)
    }
    const handleRejAccept = () => {
        let status = statusEnum
        status = { ...status, status: STATUS_ENUMS.RejectedAccept }
        setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.RejectedAccept })
        handleAddRisk(status, 'Rejected Risk [ID] has been accepted')
    }
    const handleDisApprove = () => {
        let status = statusEnum
        status = { ...status, level2: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Analyze }
        setStatusEnum({ ...statusEnum, level2: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Analyze })
        handleAddRisk(status)
    }
    const handleDisReject = () => {
        let status = statusEnum
        status = { ...status, status: STATUS_ENUMS.DisputeClosed }
        setStatusEnum({ ...statusEnum, status: STATUS_ENUMS.DisputeClosed })
        handleAddRisk(status)
    }
    const historyApiCall = () => {
        getRiskHistory(RiskDetailsById?.riskInformation?.id, orgId)
    }
    const periodApiCall = () => {
        getRiskPeriodicity(RiskDetailsById?.riskInformation?.id, loginId, orgId)
    }
    const features = JSON.parse(localStorage.getItem('features'))

    const handleWithdrawClick = (riskId) => {
        setSelectedRiskId(riskId)
        setOpenConfirmDialog(true)
    }

    const confirmWithdraw = () => {
        setOpenConfirmDialog(false)
        handleAddRisk({ level1: STATUS_ENUMS.Pending, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Inactive }, 'Risk [ID] has been successfully withdrawn')
    }
    const [ anchorEl, setAnchorEl ] = useState(null)
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setAnchorEl(null)
    }
    const open = Boolean(anchorEl)
    const convertToIssue = () => {
        navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.ISSUE.URI + RoutePath.ISSUE.ADD_ISSUE + '?riskId=' + RiskDetailsById?.riskInformation?.id)
    }
    const verifyManagerOrVacant = () => {
        if (RiskDetailsById?.riskInformation?.name === 'Vacant' && RiskDetailsById?.riskInformation?.roles.includes('Risk Manager')) {
            return true
        } else if (RiskDetailsById?.riskInformation?.deptManagers?.length > 0 && RiskDetailsById?.riskInformation?.deptManagers?.some(ele => ele !== 'Vacant') && !Object.values(userRoles).find(value => value === 'Risk Analyst')) {
            return true
        } else if (RiskDetailsById?.riskInformation?.deptManagers?.length === 1 && RiskDetailsById?.riskInformation?.deptManagers?.every(ele => ele === 'Vacant')) {
            return true
        } else {
            return Object.values(userRoles).some(value => value === 'Risk Manager')
        }
    }
    return (
        <div className='w-[100%] h-[100%] bg-card'>
            <Loading isLoading={riskDetailsLoading || createRiskDataLoading || loading} />
            <Loading isLoading={RiskDetailsByIdLoading} />

            <VerticalTimelineContainer timelineType={'Risk'} data={getRiskHistoryData} apiCall={historyApiCall} ref={ref} />
            <PeriodicityContainer data={getRiskHistoryData} apiCall={periodApiCall} ref={periodRef} />
            <div className='h-[10%]' style={{ borderBottom: '1px solid hsl(var(--primary-foreground))' }} >
                <Box sx={{ display: 'flex', height: '100%', width: '100%', alignItems: 'center', justifyContent: 'space-between' }}>
                    <div className="stepper-container">
                        <div className='h-[100%] flex flex-col justify-center cursor-pointer' onClick={() => handleClickTab(RiskType.RISK_INFO_STATUS)} >
                            <img src={riskStatusTabs === RiskType.RISK_INFO_STATUS ? '/Assets/first-active-step-bg.svg' : '/Assets/first-step-bg.svg'} style={{ height: '80%', position: 'relative' }} />
                            <div className={cn(riskStatusTabs === RiskType.RISK_INFO_STATUS && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                <div className="circle">01</div>
                                <span className='text-menu'>Risk Info</span>
                            </div>
                        </div>
                        {
                            (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Closed || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.MitigationCompleted || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Monitering || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Completed || (RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Dispute && RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Draft)) && <>
                                {RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Active && <div className='h-[100%] flex flex-col justify-center cursor-pointer' onClick={() => handleClickTab(RiskType.ASSESSMENT_STATUS)} >
                                    <img src={riskStatusTabs === RiskType.ASSESSMENT_STATUS ? '/Assets/second-act-step-bg.svg' : '/Assets/second-step-bg.svg'} style={{ height: '80%', position: 'relative' }} />
                                    <div className={cn(riskStatusTabs === RiskType.ASSESSMENT_STATUS && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        <div className="circle">02</div>
                                        <span className='text-menu'>Analyze</span>
                                    </div>
                                </div>}
                            </>
                        }
                        {
                            (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Closed || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Monitering || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Completed || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.MitigationCompleted || (RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Dispute && RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Mitigation)) && <>
                                {RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Active && <div className='h-[100%] flex flex-col justify-center cursor-pointer' onClick={() => handleClickTab(RiskType.MITIGATION_STATUS)} >
                                    <img src={riskStatusTabs === RiskType.MITIGATION_STATUS ? '/Assets/second-act-step-bg.svg' : '/Assets/second-step-bg.svg'} style={{ height: '80%', position: 'relative' }} />
                                    <div className={cn(riskStatusTabs === RiskType.MITIGATION_STATUS && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        <div className="circle">03</div>
                                        <span className='text-menu'>Mitigation</span>
                                    </div>
                                </div>}
                            </>
                        }
                        {
                            // (RiskDetailsById?.mitigation?.approachId === RiskType.REDUCTION_ID && RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Active && RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Analyze) && <>
                            (RiskDetailsById?.mitigation?.approachId === RiskType.REDUCTION_ID && RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Active && (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Closed || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Monitering || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Completed || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.MitigationCompleted)) && <>
                                <div className='h-[100%] flex flex-col justify-center cursor-pointer' onClick={() => handleClickTab(RiskType.MONITORING_STATUS)} >
                                    <img src={riskStatusTabs === RiskType.MONITORING_STATUS ? '/Assets/second-act-step-bg.svg' : '/Assets/second-step-bg.svg'} style={{ height: '80%', position: 'relative' }} />
                                    <div className={cn(riskStatusTabs === RiskType.MONITORING_STATUS && 'active', 'step')} style={{ position: 'absolute', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                                        <div className="circle">04</div>
                                        <span className='text-menu'>Monitoring</span>
                                    </div>
                                </div>
                            </>
                        }
                    </div>
                    <Box className='flex pr-4'>
                        <Tooltip title="More" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <MoreVerticalIcon className='cursor-pointer' height='20px' onClick={(e) => handleClick(e)} color='hsl(var(--primary))' />
                        </Tooltip>
                        {/* <Tooltip title="Chart & TimeLine" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                            <IconButton sx={{ mr: 1 }} onClick={() => navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + RoutePath.CHAT_AND_TIMELINE.URI + '/' + riskDetails?.riskId)}>
                                <RiChatHistoryLine color='hsl(var(--primary))' />
                            </IconButton>
                        </Tooltip> */}
                        <Menu
                            id="lock-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleClose}
                            slotProps={{
                                list: {
                                    'aria-labelledby': 'lock-button',
                                    role: 'listbox'
                                }
                            }}
                            anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'left' }}

                        >

                            {!isEditTrue &&
                             (featValid(features, UPDATE_RISK) || verifyManagerOrVacant()) &&
                             (RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Pending ||
                                (RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment &&
                                     RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending && verifyManagerOrVacant())) &&
                                      riskStatusTabs === RiskType.RISK_INFO_STATUS &&

                                 <div onClick={handleClickEdit} className='flex justify-between w-full items-center py-[9px] px-[17px]'>

                                     <span>Edit</span>
                                     {/* <IconButton

                                        > */}
                                     <MdEdit onClick={handleClickEdit} className='h-[17px] '
                                         color='hsl(var(--primary))'
                                     />
                                 </div>

                            }
                            {
                                !isEditTrue &&
                                (featValid(features, UPDATE_RISK) || verifyManagerOrVacant()) &&
                                 riskStatusTabs !== RiskType.RISK_INFO_STATUS &&
                                 RiskDetailsById?.riskInformation?.level1 !== STATUS_ENUMS.Pending &&
                                  RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment &&
                                 (verifyManagerOrVacant() ||
                                 (riskStatusTabs === RiskType.MONITORING_STATUS &&
                                     RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Monitering &&
                                     RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved &&
                                     RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Approved)) &&
                                // <Tooltip title="Edit Risk" className='flex justify-between w-full items-center' placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <div className='flex justify-between w-full items-center py-[9px] px-[17px]'>

                                        <span>Edit</span>

                                        <MdEdit size={30} onClick={handleClickEdit} className='h-[17px]'
                                            color='hsl(var(--primary))'
                                        />
                                    </div>
                                // </Tooltip>
                            }

                            {
                                !isEditTrue && (featValid(features, UPDATE_RISK) || verifyManagerOrVacant()) &&
                                ((RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Rejected &&
                                     RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending &&
                                      Object.values(userRoles).some(value => value === 'Risk Analyst')) ||
                                      (RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved &&
                                         RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Rejected)) &&
                                         RiskDetailsById.riskInformation.status === STATUS_ENUMS.Active &&
                                // <Tooltip title="Edit Risk" className='flex justify-between w-full items-center' placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <div className='flex justify-between w-full items-center py-[9px] px-[17px]'>

                                        <span>Edit</span>

                                        <MdEdit onClick={handleClickEdit} className='h-[17px] '
                                            color='hsl(var(--primary))'
                                        />
                                    </div>
                                // </Tooltip>
                            }
                            {
                                <MenuItem>
                                    {/* <Tooltip className='flex-shrink-0' title="Timeline" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}> */}

                                    <div className='cursor-pointer active:scale-90 transition-transform duration-150 flex justify-between w-full' onClick={() => { toggleDrawer(); handleClose() }}>
                                        <span>Timeline</span>
                                        <img className='w-8' src='/Assets/chatTimeline.svg' />
                                    </div>
                                    {/* </Tooltip> */}
                                </MenuItem>

                            }
                            {
                                <MenuItem>
                                    {/* <Tooltip className='flex-shrink-0 w-full flex justify-between' title="Periodicity" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}> */}
                                    <div onClick={() => { periodToggleDraw(); handleClose() }} className='flex justify-between w-full items-center'>

                                        <span>Periodicity</span>
                                        <img className='w-9 cursor-pointer flex-shrink-0' src='/Assets/analysis.svg' />
                                    </div>
                                    {/* </Tooltip> */}
                                </MenuItem>
                            }
                            {verifyManagerOrVacant() && <MenuItem
                                onClick={() => convertToIssue()}
                            >
                                <div className='flex w-full justify-between items-center gap-4'>
                                    <span className='text-[hsl(var(--Risk))]'>
                                    Convert to Issue
                                    </span>
                                    <IssueSelect width='25px' height='28px' isActive={true} color='hsl(var(--Risk))' />
                                </div>
                            </MenuItem>}
                        </Menu>

                        {/* <div className='mr-3'>
                            <Card>
                                <div className='flex justify-between gap-2 px-5 py-3'>
                                    <Tooltip className='flex-shrink-0' title="Timeline" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>

                                        <div className='cursor-pointer active:scale-90 transition-transform duration-150' onClick={() => toggleDrawer()}><img className='w-8' src='/Assets/chatTimeline.svg' /></div>
                                    </Tooltip>
                                    <div className='h-[25px] w-[1.5px] flex-shrink-0 bg-[hsl(var(--primary-table-head))]'></div>
                                    <Tooltip className='flex-shrink-0' title="Periodicity" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                        <img className='w-9 cursor-pointer flex-shrink-0' src='/Assets/analysis.svg' onClick={() => periodToggleDraw()} />
                                    </Tooltip>
                                </div>
                            </Card>
                        </div> */}
                    </Box>
                </Box>
            </div>
            <div className={cn('w-full overflow-auto',
                ((!isEditTrue && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Pending && RiskDetailsById?.riskInformation?.department === userDepartment && verifyManagerOrVacant()) ||
                    (!isEditTrue && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending && RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()) ||
                    (!isEditTrue && riskStatusTabs === RiskType.MITIGATION_STATUS && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Approved && RiskDetailsById?.mitigation?.approachId && RiskDetailsById.riskInformation.status === STATUS_ENUMS.Mitigation && RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()) ||
                    (!isEditTrue && riskStatusTabs === RiskType.MONITORING_STATUS && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Approved && RiskDetailsById?.mitigation?.approachId && RiskDetailsById.riskInformation.status === STATUS_ENUMS.Monitering && RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant()) ||
                    (!isEditTrue && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Approved &&
                        RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Completed &&
                        RiskDetailsById?.mitigation?.approachId && RiskDetailsById?.riskInformation?.department === userDepartment &&
                        verifyManagerOrVacant()) ||
                    ((((RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Closed ||
                        RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.DisputeClosed ||
                        RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.RejectedAccept) &&
                        RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved &&
                        RiskDetailsById?.riskInformation.level2 === STATUS_ENUMS.Approved) ||
                        RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.RejectedAccept ||
                        RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.DisputeClosed) &&
                        verifyManagerOrVacant()) ||
                    ((
                        (!isEditTrue && RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Active &&
                            RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Rejected &&
                            RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending) ||
                        ((!isEditTrue && RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Active) &&
                            RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved &&
                            RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Rejected)) &&
                        verifyManagerOrVacant()) ||
                    (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Dispute &&
                        RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved &&
                        RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Rejected &&
                        RiskDetailsById?.riskInformation?.department === userDepartment &&
                        verifyManagerOrVacant()) ||
                    (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Resubmit) ||
                    (!isEditTrue && RiskDetailsById?.riskInformation?.department === userDepartment && RiskDetailsById?.riskInformation?.createdBy === +userId && RiskDetailsById?.riskInformation?.level1 === 8) ||
                    (((RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Active && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Rejected && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending) ||
                        ((RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Active || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.DisputeClosed) && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved &&
                            RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Rejected)) && !isEditTrue) || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.MitigationCompleted ||
                    (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Resubmit))
                    ? 'h-[80%]'
                    : 'h-[90%]')} >
                {riskStatusTabs === RiskType.RISK_INFO_STATUS && !isEditTrue && <>
                    <div className={cn('overflow-auto')} ><RiskInformation RiskDetailsById={RiskDetailsById?.riskInformation} /></div>
                </>}
                {riskStatusTabs === RiskType.ASSESSMENT_STATUS && !isEditTrue && <AssesmentView RiskDetailsById={RiskDetailsById?.analyzeResponse} />}
                {riskStatusTabs === RiskType.MITIGATION_STATUS && !isEditTrue && <MitigationView />}
                {riskStatusTabs === RiskType.MONITORING_STATUS && !isEditTrue && <MonitoringView />}
                {riskStatusTabs === RiskType.RISK_INFO_STATUS && isEditTrue && <AddRisk riskInfoData={RiskDetailsById?.riskInformation}
                    ref={addRiskRef} isEditTrue={isEditTrue} statusEnum={statusEnum} setStatusEnum={setStatusEnum} handleApprove={handleApprove} handleReject={handleReject} riskInfo={RiskDetailsById?.riskInformation} editFormData={formData} setIsEditTrue={setIsEditTrue} />}
                {riskStatusTabs === RiskType.ASSESSMENT_STATUS && isEditTrue && <AssesmentEdit setIsEditTrue={setIsEditTrue} isEditTrue={isEditTrue} riskScore={riskScore} setRiskScore={setRiskScore} formData={formData} setformData={setformData} RiskDetailsById={RiskDetailsById} />}
                {riskStatusTabs === RiskType.MITIGATION_STATUS && isEditTrue && <MitigationEdit setIsEditTrue={setIsEditTrue} />}
                {riskStatusTabs === RiskType.MONITORING_STATUS && isEditTrue && <MonitoringEdit setIsEditTrue={setIsEditTrue} />}
            </div>
            {((!isEditTrue && RiskDetailsById?.riskInformation?.department === userDepartment && RiskDetailsById?.riskInformation?.createdBy === +userId && RiskDetailsById?.riskInformation?.level1 === 8) || (!isEditTrue && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Pending && RiskDetailsById?.riskInformation?.department === userDepartment && verifyManagerOrVacant())) &&
                <div className='flex flex-row justify-end items-center h-[10%]' >
                    {!isEditTrue && RiskDetailsById?.riskInformation?.department === userDepartment && RiskDetailsById?.riskInformation?.createdBy === +userId && RiskDetailsById?.riskInformation?.level1 === 8 && RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Active && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'><Button
                        disabled={createRiskDataLoading}
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                        onClick={() => handleWithdrawClick(RiskDetailsById?.riskInformation?.referenceId)}>
                        Withdraw
                    </Button></div>}
                    {!isEditTrue && RiskDetailsById?.riskInformation?.department === userDepartment && RiskDetailsById?.riskInformation?.createdBy === +userId && RiskDetailsById?.riskInformation?.level1 === 8 && RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Draft && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'><Button
                        disabled={createRiskDataLoading}
                        style={{ color: 'hsl(var(--card))', borderColor: 'hsl(var(--primary))' }}
                        onClick={() => {
                            if (verifyManagerOrVacant()) {
                                setPreApprovalPopup(true)
                            } else if ((!L1Approval && !L2Approval) || (!L1Approval && L2Approval)) {
                                let status = statusEnum
                                status = { ...status, level1: !L1Approval && !L2Approval ? STATUS_ENUMS.Approved : !L1Approval && L2Approval ? STATUS_ENUMS.Approved : STATUS_ENUMS.Pending, level2: !L1Approval && !L2Approval ? STATUS_ENUMS.Approved : STATUS_ENUMS.Pending, status: !L1Approval && !L2Approval ? STATUS_ENUMS.Analyze : STATUS_ENUMS.Active }
                                setStatusEnum({ ...statusEnum, level1: !L1Approval && !L2Approval ? STATUS_ENUMS.Approved : !L1Approval && L2Approval ? STATUS_ENUMS.Approved : STATUS_ENUMS.Pending, level2: !L1Approval && !L2Approval ? STATUS_ENUMS.Approved : STATUS_ENUMS.Pending, status: STATUS_ENUMS.Active })
                                handleAddRisk(status, 'Risk [ID] has been successfully submitted')
                            } else {
                                handleAddRisk({ level1: STATUS_ENUMS.Pending, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Active }, 'Risk [ID] has been successfully submitted')
                            }
                        }}>
                        Submit
                    </Button></div>}
                    {!isEditTrue && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Pending && RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.Draft && RiskDetailsById?.riskInformation?.department === userDepartment && verifyManagerOrVacant() && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                        <Button onClick={() => { setEditState({ right: true }); setCommentsDrawerTitle('Deny') }}
                            variant='outline'
                            style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                            disabled={createRiskDataLoading}
                        >
                            Deny
                        </Button>
                        <Button disabled={createRiskDataLoading} onClick={() => {
                            const reqBody = [
                                {
                                    recipientUserId: RiskDetailsById?.riskInformation?.createdBy,
                                    message: `Risk ${RiskDetailsById?.riskInformation?.referenceId} has been accepted by the department head.`,
                                    kind: 3
                                },
                                {
                                    recipientUserId: RiskDetailsById?.riskInformation?.ownerId,
                                    message: `Risk ${RiskDetailsById?.riskInformation?.referenceId} has been accepted by the department head. Awaiting your approval.`,
                                    kind: 3
                                }
                            ]
                            reqBody?.map((mapDt, _) => instance.post(EndPoints.BASE_ENDPOINT + '/api/v1/core/Notification/send', mapDt))
                            handleApprove(null, 'Risk [ID] has been accepted')
                        }}>
                            Accept
                        </Button>
                    </div>}
                </div>
            }
            {
                !isEditTrue && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending && RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant() &&
                <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                    <Button onClick={() => { setEditState({ right: true }); setCommentsDrawerTitle('Reject') }}
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                        disabled={createRiskDataLoading}
                    >
                        Reject
                    </Button>
                    <Button onClick={() => handleApprove(null, 'Risk [ID] has been approved')} disabled={createRiskDataLoading}
                    >
                        Approve
                    </Button>
                </div>
            }
            {
                !isEditTrue && riskStatusTabs === RiskType.MITIGATION_STATUS && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Approved && RiskDetailsById?.mitigation?.approachId && RiskDetailsById.riskInformation.status === STATUS_ENUMS.Mitigation && RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant() && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'><Button onClick={() => handleApprove('Mitigation', 'Analyze & Mitigation changes have been saved for Risk [ID]')} disabled={createRiskDataLoading}>
                    {RiskDetailsById?.mitigation?.approachId !== 3 ? 'Complete' : 'Submit'}
                </Button></div>
            }
            {
                !isEditTrue && riskStatusTabs === RiskType.MONITORING_STATUS && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Approved && RiskDetailsById?.mitigation?.approachId && RiskDetailsById.riskInformation.status === STATUS_ENUMS.Monitering && RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant() && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'><Button disabled={Number(taskPercentage) !== 100 || createRiskDataLoading} onClick={() => handleApprove('Monitoring', 'Risk [ID] marked as complete')}>
                    Complete
                </Button></div>
            }
            {
                !isEditTrue && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Approved && (RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Completed || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.MitigationCompleted) && RiskDetailsById?.mitigation?.approachId && RiskDetailsById?.riskInformation?.department === userDepartment && verifyManagerOrVacant() && <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'><Button onClick={() => handleApprove('Monitoring', 'Risk [ID] has been closed')} disabled={createRiskDataLoading}>
                    Close Risk
                </Button></div>
            }
            {
                (((RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Closed || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.RejectedAccept) && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved && RiskDetailsById?.riskInformation.level2 === STATUS_ENUMS.Approved) || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.RejectedAccept) && verifyManagerOrVacant() && !isEditTrue &&
                <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                    <Button onClick={() => handleRetrieve('Risk [ID] has been retrieved')} disabled={createRiskDataLoading}>
                        Retrieve Risk
                    </Button>
                </div>
            }
            {
                ((RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Active && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Rejected && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending) ||
                    ((RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Active || RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.DisputeClosed) && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved &&
                        RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Rejected)) && !isEditTrue &&
                <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                    <div className='flex items-center gap-6'>
                        <div className='text-primary underline  cursor-pointer' onClick={() => setIsViewComments({ right: true })}>View Comments</div>
                        {/* RiskDetailsById?.riskInformation?.roles?.includes('Risk Manager')  */}
                        {((RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Rejected && verifyManagerOrVacant() && RiskDetailsById?.riskInformation?.department === userDepartment && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved && RiskDetailsById?.riskInformation?.status !== STATUS_ENUMS.DisputeClosed)) &&
                            <Button variant='outline' onClick={() => handleDisMove('Risk [ID] has been raised as a dispute')} disabled={createRiskDataLoading}>
                                Dispute
                            </Button>}
                        {((RiskDetailsById?.riskInformation?.createdBy === +userId && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Rejected && RiskDetailsById?.riskInformation?.department === userDepartment) ||
                            (RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Rejected && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved && verifyManagerOrVacant() && RiskDetailsById?.riskInformation?.department === userDepartment)) &&
                            <Button onClick={() => handleRejAccept()} disabled={createRiskDataLoading}>
                                Accept
                            </Button>}

                    </div>
                </div>
            }

            {
                RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Resubmit &&
                <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                    <div className='flex items-center gap-6'>
                        <div className='text-primary underline  cursor-pointer' onClick={() => setIsViewComments({ right: true })}>View Comments</div>
                        <Button onClick={() => {
                            const reqBody = {
                                recipientUserId: RiskDetailsById?.riskInformation?.level1 === 11 && RiskDetailsById?.riskInformation?.level2 === 8 ? RiskDetailsById?.riskInformation?.raisedId : RiskDetailsById?.riskInformation?.ownerId,
                                message: `Changes to Risk ${RiskDetailsById?.riskInformation?.referenceId} have been Updated. Awaiting your approval.`,
                                kind: 3
                            }
                            instance.post(EndPoints.BASE_ENDPOINT + '/api/v1/core/Notification/send', reqBody)
                            handleAddRisk(RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Rejected && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Pending ? { level1: STATUS_ENUMS.Pending, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Active } : { level1: STATUS_ENUMS.Approved, level2: STATUS_ENUMS.Pending, status: STATUS_ENUMS.Active })
                        }}
                        disabled={createRiskDataLoading}
                        >
                            Resubmit
                        </Button>
                    </div>
                </div>
            }

            {
                RiskDetailsById?.riskInformation?.status === STATUS_ENUMS.Dispute && RiskDetailsById?.riskInformation?.level1 === STATUS_ENUMS.Approved && RiskDetailsById?.riskInformation?.level2 === STATUS_ENUMS.Rejected && RiskDetailsById?.riskInformation?.ownerDepartmentId === userDepartment && verifyManagerOrVacant() && !isEditTrue &&
                <div className='flex justify-end items-center gap-6 pr-4 h-[10%]'>
                    <Button onClick={() => handleDisReject()}
                        variant='outline'
                        style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                        disabled={createRiskDataLoading}
                    >
                        Reject
                    </Button>
                    <Button onClick={() => handleDisApprove()} disabled={createRiskDataLoading}>
                        Approve
                    </Button>
                </div>
            }
            {/* </div> */}
            {/* </div> */}
            <Dialog
                maxWidth
                open={openWithdrawnPopup}
            >
                <Box sx={{ width: 400 }} >
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--destructive))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Warning</div>
                    </DialogTitle>
                    <DialogContent sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'col', justifyContent: 'center', alignItems: 'center' }}>
                        <p className='text-muted pt-[24px] text-[14px]'>
                            {`This Risk has been already withdrawn. ${'You'} can't proceed further`}
                        </p>
                    </DialogContent>
                    <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <div className='d-flex content-end'>
                            <Button
                                variant='outline'
                                style={{ color: 'hsl(var(--destructive))', borderColor: 'hsl(var(--destructive))' }}
                                onClick={() => {
                                    navigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.RISK.URI + '/' + INITIATE)
                                    setOpenWithdrawnPopup(false)
                                }}
                            >
                                {'Close'}
                            </Button>
                        </div>
                    </DialogActions>
                </Box>
            </Dialog>
            <Dialog open={openConfirmDialog} onClose={() => setOpenConfirmDialog(false)}>
                <Box className='md:w-[400px] lg:w-[600px]'>
                    <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                        <h1 className='md:text-lg lg:text-xl font-bold text-[#fff]' style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Withdraw Confirmation</h1>
                    </DialogTitle>
                    <DialogContent sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'col', justifyContent: 'center', alignItems: 'center' }}>
                        <p className='text-muted pt-[24px] md:text-[14px] lg:text-[16px]'>
                            {`Do you want to withdraw the risk ID ${selectedRiskId} ?`}
                        </p>
                    </DialogContent>
                    <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-end' }}>
                        <Button variant="outline" onClick={() => setOpenConfirmDialog(false)}>
                            No
                        </Button>
                        <Button onClick={confirmWithdraw} style={{ color: '#fff', backgroundColor: 'hsl(var(--primary))' }}>
                            Yes
                        </Button>
                    </DialogActions>
                </Box>
            </Dialog>

            <ViewComments
                isViewComments={isViewComments}
                setIsViewComments={setIsViewComments}
            />
            <Dialog
                open={preApprovalPopup}
                // onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'center' }}>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#fff' }}>Information</div>
                </DialogTitle>
                <DialogContent style={{ padding: '15px 30px 15px 30px' }}>
                    <DialogContentText id="alert-dialog-description">
                        This risk will be auto-approved as the Creator and Approver are the same person.
                    </DialogContentText>
                </DialogContent>
                <DialogActions style={{ borderTop: '2px solid hsl(var(--border))', width: '100%', display: 'flex', padding: '15px 30px 15px 30px', flexDirection: 'row', justifyContent: 'flex-start' }}>
                    <div className='d-flex content-end'>
                        <Button
                            style={{ borderColor: 'hsl(var(--primary))' }}
                            onClick={() => {
                                setPreApprovalPopup(false)
                                let status = statusEnum
                                status = { ...status, level1: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Active }
                                setStatusEnum({ ...statusEnum, level1: STATUS_ENUMS.Approved, status: STATUS_ENUMS.Active })
                                handleAddRisk(status, 'Risk [ID] has been accepted')
                            }}
                        >
                            {'Yes, Proceed'}
                        </Button>
                    </div>
                </DialogActions>
            </Dialog>
            <CommentsDrawer handleReject={handleReject} setEditState={setEditState} editState={editState} comments={comments} setComments={setComments} loading={createRiskDataLoading} title={CommentsDrawerTitle} />
        </div>
    )
}

export default ViewRiskByID
